export default "/images/e51e4d6f44d77f2e87307abedbd793e3.avif";